import React from 'react';
import FooterBarsStyles from './FooterBars.module.scss';

export const FooterBars: React.FC = () => {
  return (
    <div className={FooterBarsStyles.footer_bars}>
      <hr className={FooterBarsStyles.footer_bars__top} />
      <hr className={FooterBarsStyles.footer_bars__mid} />
      <hr className={FooterBarsStyles.footer_bars__bottom} />
    </div>
  );
};
